"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getNodesInRange = getNodesInRange;
exports.isFirefox = isFirefox;
exports.selectAll = selectAll;
exports.selectNodes = selectNodes;
var _DOM = require("./DOM");
var _Logger = _interopRequireDefault(require("./Logger"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var logger = new _Logger["default"]('Range');
function selectNodes(nodes) {
  if (nodes.length > 0) {
    // update selected range
    var selection = window.getSelection();
    var newRange = document.createRange();
    newRange.setStart((0, _DOM.getFirstEndNode)(nodes[0]), 0);
    var lastNode = (0, _DOM.getFirstEndNode)(nodes[nodes.length - 1]);
    newRange.setEnd(lastNode, lastNode.textContent.length);
    selection.removeAllRanges();
    selection.addRange(newRange);
  }
}
function isFirefox() {
  var userAgent = navigator.userAgent.toLowerCase();
  return userAgent.indexOf('firefox') > -1;
}
function getNodesInRange(range) {
  var updateRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var startContainer = range.startContainer,
    endContainer = range.endContainer,
    commonAncestorContainer = range.commonAncestorContainer,
    startOffset = range.startOffset,
    endOffset = range.endOffset;
  var nodes = [];
  var lastNode = isFirefox() ? (0, _DOM.getLastEndNode)(endContainer) : (0, _DOM.getFirstEndNode)(endContainer);
  var firstNode = (0, _DOM.getFirstEndNode)(startContainer);
  var node = firstNode;
  while (node) {
    var currentNodeRef = node;
    if (node.parentNode.nodeName === 'SPAN' && node.parentNode.textContent === node.textContent && (node !== firstNode && node !== lastNode || node === firstNode && node !== lastNode && startOffset === 0 || node === lastNode && node !== firstNode && endOffset === node.textContent.length || firstNode === lastNode && startOffset === 0 && endOffset === node.textContent.length || (startContainer.nodeType !== Node.TEXT_NODE || endContainer.nodeType !== Node.TEXT_NODE) && startOffset === 0 && endOffset === 1)) {
      nodes.push(node.parentNode);
      currentNodeRef = node.parentNode;
    } else if (node === firstNode) {
      var left = node.textContent.substring(0, startOffset);
      var middle = node === lastNode ? node.textContent.substring(startOffset, endOffset) : node.textContent.substring(startOffset);
      var right = node === lastNode ? node.textContent.substring(endOffset) : '';
      if (left) {
        node.parentNode.insertBefore(document.createTextNode(left), node);
      }
      if (middle) {
        var wrapper = document.createElement('span');
        wrapper.innerText = middle;
        node.parentNode.insertBefore(wrapper, node);
        nodes.push(wrapper);
        currentNodeRef = wrapper;
      } else {
        currentNodeRef = node.parentNode;
      }
      if (right) {
        node.parentNode.insertBefore(document.createTextNode(right), node);
      }
      node.parentNode.removeChild(node);
    } else if (node === lastNode) {
      if (node.textContent.length) {
        var _middle = node.textContent.substring(0, endOffset);
        var _right = node.textContent.substring(endOffset);
        var _wrapper = document.createElement('span');
        _wrapper.innerText = _middle;
        node.parentNode.insertBefore(_wrapper, node);
        if (_right) {
          node.parentNode.insertBefore(document.createTextNode(_right), node);
        }
        node.parentNode.removeChild(node);
        nodes.push(_wrapper);
        currentNodeRef = _wrapper;
      }
    } else if (node.nodeType === Node.TEXT_NODE) {
      var _wrapper2 = document.createElement('span');
      node.parentNode.insertBefore(_wrapper2, node);
      _wrapper2.appendChild(node);
      nodes.push(_wrapper2);
      currentNodeRef = _wrapper2;
    } else {
      logger.warn('Unhandled node', node);
    }
    if (node === lastNode) {
      break;
    }
    node = (0, _DOM.getNextNode)(currentNodeRef, commonAncestorContainer);
  }
  updateRange && selectNodes(nodes);
  return nodes;
}
function selectAll(rootNode) {
  var firstNode = (0, _DOM.getFirstEndNode)(rootNode);
  var lastNode = (0, _DOM.getLastEndNode)(rootNode);
  if (firstNode && lastNode) {
    var range = document.createRange();
    range.selectNodeContents(rootNode);
    range.setStart(firstNode, 0);
    range.setEnd(lastNode, lastNode.textContent.length);
    return range;
  }
  return false;
}